/** 回购页面 **/
<template>
  <div class="home data-panel-home">
    <Layout
      type="HOME"
      :pageTitle="$t('pageTitle')"
      titleSrc="/menu/homeIcon_black.png"
    >
      <!-- <Tips
        :title="$t('tipsTitle')"
        :tips="$t('tipsDetail')"
        class="buyback-tips"
      /> -->
      <!-- <CommitExchange></CommitExchange> -->
      <el-alert
        title="由于京东服务商城停止运营，后续将不再支持京东卡兑换，您可选择提现支付渠道或对公打款"
        type="warning"
        description="已兑换过的JD卡请在下方兑换记录中点击 查看卡密 获取。复制卡密后，请打开JD官网（jd.com），登录并在我的钱包中选择礼品卡，输入卡密即可兑换，移动端请点击 我的-我的钱包-礼品卡-绑定新卡 完成操作。"
        show-icon
        :closable="false">
      </el-alert>
      <ExchangeList></ExchangeList>
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import Layout from "@/components/DatePanel/Layout.vue";
import Tips from '@/components/Common/Tips.vue';
import CommitExchange from '@/components/DatePanel/Exchange/CommitExchange.vue';
import ExchangeList from '@/components/DatePanel/Exchange/ExchangeList.vue';

export default {
  name: "home",
  components: {
    Header,
    Layout,
    Tips,
    CommitExchange,
    ExchangeList
  },
  data() {
    return {};
  },
  computed: mapState({
    inviteCodeStatus: state => state.inviteCode.status
  }),
  created() {
    let that = this;
  },
  methods: {
    ...mapActions([""])
  }
};
</script>

<style scoped lang="stylus"></style>

<i18n>
{
  "en": {
    "pageTitle": "JD卡兑换",
    "tipsDetail": [
      "<special>1. 由于京东服务商城停止运营，后续将不再支持京东卡兑换，可选择提现支付渠道/对公打款。<special>",
      "<special>2. 已兑换过的JD卡请在下方兑换记录中点击 查看卡密 获取。复制卡密后，请打开JD官网（jd.com），登录并在我的钱包中选择礼品卡，输入卡密即可兑换，移动端请点击 我的-我的钱包-礼品卡-绑定新卡 完成操作。<special>"
    ],
    "tipsTitle": "兑换注意事项"  
  }
}
</i18n>
